// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../node_modules/css-loader/index.js!../node_modules/postcss-loader/lib/index.js!../node_modules/sass-loader/dist/cjs.js!../node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!../node_modules/vue-style-loader/index.js!../node_modules/css-loader/index.js??ref--10-2!../node_modules/postcss-loader/lib/index.js??ref--10-3!../node_modules/sass-loader/dist/cjs.js??ref--10-4!./style.scss");
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = require("!../node_modules/vue-style-loader/lib/addStylesClient.js")("75d77958", content, true, {});


//////////////////
// WEBPACK FOOTER
// ./scss/style.scss
// module id = DsJ2
// module chunks = 0